export default __webpack_public_path__ + "static/media/1.f8501098.jpg";